import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import _ from 'lodash'

export const types = {
    SET_RANKING_REPORT_URLS1: 'url-ranking-report/SET_RANKING_REPORT_URLS1',
    SET_RANKING_REPORT_URLS2: 'url-ranking-report/SET_RANKING_REPORT_URLS2',
    SET_RANKING_REPORT_MAPPED_URLS: 'url-ranking-report/SET_RANKING_REPORT_MAPPED_URLS'
}

const state = {
    urls1: [],
    urls2: [],
    mappedUrls: [],
}

const mutations = {
    [types.SET_RANKING_REPORT_URLS1]: function (state, data) {
        state.urls1 = data
    },
    [types.SET_RANKING_REPORT_URLS2]: function (state, data) {
        state.urls2 = data
    },
    [types.SET_RANKING_REPORT_MAPPED_URLS]: function (state, data) {
        state.mappedUrls = data
    }
}

const actions = {
    getUrlData: async function ({ commit }, { clientId, filters }) {
        const msv = JSON.parse(localStorage.getItem('msv')) || {}
        filters.msv = msv[clientId] || 1

        const { snapshot1, snapshot2, rankZones, mapByKeyword, columnFilters, ...otherFilters } = filters;
        let response;
        if (filters && filters.advancedFilters) {
            const params1 = convertAdvancedOptionsToURLParams({ ...otherFilters, snapshot_date: snapshot1 });
            const params2 = convertAdvancedOptionsToURLParams({ ...otherFilters, snapshot_date: snapshot2 });

            response = await Promise.all([
                httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: params1 }, { encode: false }),
                httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: params2 }, { encode: false }),
            ])

        } else {
            response = await Promise.all([
                httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: { ...otherFilters, snapshot_date: snapshot1 } }),
                httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: { ...otherFilters, snapshot_date: snapshot2 } })
            ])
        }

        if (!response || !Array.isArray(response) || !response[0].data || !response[1].data) {
            return
        }

        commit(types.SET_RANKING_REPORT_URLS1, response[0].data.urls)
        commit(types.SET_RANKING_REPORT_URLS2, response[1].data.urls)

        const mappedUrls = mapUrls(state.urls1, state.urls2, rankZones, mapByKeyword, columnFilters)
        commit(types.SET_RANKING_REPORT_MAPPED_URLS, mappedUrls)

        return mappedUrls
    },
    recalculateData: function ({ commit }, { rankZones, mapByKeyword, columnFilters }) {
        const mappedUrls = mapUrls(state.urls1, state.urls2, rankZones, mapByKeyword, columnFilters)
        commit(types.SET_RANKING_REPORT_MAPPED_URLS, mappedUrls)
    },
    resetUrlsList: async function ({ commit }) {
        commit(types.SET_RANKING_REPORT_URLS1, [])
        commit(types.SET_RANKING_REPORT_URLS2, [])
        commit(types.SET_RANKING_REPORT_MAPPED_URLS, [])
    }
}

function mapUrls(data1, data2, rankZones, mapByKeyword, columnFilters) {
    data1 = _.cloneDeep(data1)
    data2 = _.cloneDeep(data2)
    const sumRankings = (item, zones) => {
        if (!item) {
            return 0
        }
        return zones.reduce((acc, zone) => {
            if (mapByKeyword) {
                zone = 'keyword_' + zone
            }
            if (!item[zone]) return acc
            acc += item[zone]
            return acc;
        }, 0)
    }

    // Since data sets can contain different amount of items, we should map by bigger one
    const maxLength = Math.max(data1.length, data2.length)
    const mappedData = []
    for (let i = maxLength - 1; i >= 0; i--) {
        let item1, item2
        let mappedItem = {}
        if (!!data1[i]) {
            item1 = data1.pop()
            item2 = data2.find(item => item._id === item1._id)
            if (item2) {
                data2.splice(data2.indexOf(item2), 1)
            }
            mappedItem = {
                contentBriefUrl: item1.content_brief_url,
                label: item1.label,
                keywordTotal: item1.keyword_total,
                totalMsv: item1.total_msv,
            }
        } else {
            item2 = data2.pop()
            item1 = data1.find(item => item._id === item2._id)
            if (item1) {
                data1.splice(data1.indexOf(item1), 1)
            }
            mappedItem = {
                contentBriefUrl: item2.content_brief_url,
                label: item2.label,
                keywordTotal: item2.keyword_total,
                totalMsv: item2.total_msv,
            }
        }

        const ranking1 = sumRankings(item1, rankZones)
        const ranking2 = sumRankings(item2, rankZones)
        const change = ranking1 - ranking2
        let changePercent;
        if (ranking2 === 0) {
            changePercent = ranking1 === 0 ? 0 : 100
        } else {
            changePercent = (ranking1 - ranking2) * 100 / ranking2
        }

        changePercent = Math.round(changePercent)
        mappedItem = { ...mappedItem, ranking1, ranking2, change, changePercent }

        mappedData.push(mappedItem)
    }

    const filteredData = applyColumnFilters(mappedData, columnFilters)

    return filteredData
}

function applyColumnFilters(allItems, columnFilters) {
    if (!columnFilters || !columnFilters.length) {
        return allItems
    }

    const operatorsMap = {
        equal: (originalValue, targetValue) => {
            return originalValue === targetValue
        },
        ne: (originalValue, targetValue) => {
            return originalValue !== targetValue
        },
        gt: (originalValue, targetValue) => {
            return originalValue > targetValue
        },
        lt: (originalValue, targetValue) => {
            return originalValue < targetValue
        },
        lte: (originalValue, targetValue) => {
            return originalValue <= targetValue
        },
        gte: (originalValue, targetValue) => {
            return originalValue >= targetValue
        }
    }

    return allItems.filter(item => {
        return !columnFilters.some(filter => !operatorsMap[filter.operator](+item[filter.property], +filter.value))
    })
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}